import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Nav = () => {
    const location = useLocation();

    return (
        <nav>
            <ul className='flex justify-center items-center gap-5 text-md'>
                <Link to="/training">
                    <li
                        className={`px-4 py-2 border-b-2 ${location.pathname === '/training' || location.pathname === '/' ? 'text-btn-primary border-btn-primary font-semibold text-[16px]' : 'border-none text-[16px]'
                            } hover:text-btn-primary cursor-pointer `}
                    >
                        Training
                    </li>
                </Link>
                <Link to="/models">
                    <li
                        className={`px-4 py-2 border-b-2 ${location.pathname === '/models' ? 'text-btn-primary border-btn-primary font-semibold  text-[16px]' : 'border-none text-[16px]'
                            } hover:text-btn-primary cursor-pointer`}
                    >
                        Models
                    </li>
                </Link>
                <Link to="/inference">
                    <li
                        className={`px-4 py-2 border-b-2 ${location.pathname === '/inference' ? 'text-btn-primary border-btn-primary font-semibold  text-[16px]' : 'border-none text-[16px]'
                            } hover:text-btn-primary cursor-pointer`}
                    >
                        Inference
                    </li>
                </Link>
                 <Link to="/forecast">
                    <li
                        className={`px-4 py-2 border-b-2 ${location.pathname === '/forecast' ? 'text-btn-primary border-btn-primary font-semibold  text-[16px]' : 'border-none text-[16px]'
                            } hover:text-btn-primary cursor-pointer`}
                    >
                        Forecast
                    </li>
                </Link>
                <Link to="/howto">
                    <li
                        className={`px-4 py-2 border-b-2 ${location.pathname === '/howto' ? 'text-btn-primary border-btn-primary font-semibold  text-[16px]' : 'border-none text-[16px]'
                            } hover:text-btn-primary cursor-pointer`}
                    >
                        How To
                    </li>
                </Link>
            </ul>
        </nav>
    );
};

export default Nav;
